export enum NavigationEvent {
  QUIZ_STARTED = 'navigation.quiz-started',
  QUIZ_FINISHED = 'navigation.quiz-finished',
  QUIZ_STEP_SUBMIT = 'navigation.quiz-step-submit',
  ONBOARDING_STARTED = 'navigation.onBoarding-started',
  ONBOARDING_FINISHED = 'navigation.onBoarding-finished',
  RANGE_PRICES = 'navigation.range-prices',
  IS_MOTHER = 'navigation.is-mother',
  REFERRAL_CODE_SHARE = 'navigation.referral-code-share',
  DOWNLOAD_APP_BUTTONS = 'downloadAppButton',
  VIEW_POST_ORDER_MODAL = 'myLKPostOrderModalView',
  CLOSE_POST_ORDER_MODAL = 'myLKPostOrderModalClose',
  MANAGE_PLAN = 'navigation.managePlan',
  FB_SIGN_UP_BUTTON = 'navigation.facebook-sign-up-button',
  DELETE_ACCOUNT_LINK = 'navigation.delete-account-link',
  SUBSCRIPTION_TAP_2WEEKS = 'navigation.subscriptionTap2weeks',
  SUBSCRIPTION_TAP_MONTHLY = 'navigation.subscriptionTapMonthly',
  SUBSCRIPTION_TAP_BIMONTHLY = 'navigation.subscriptionTapBimonthly',
  SUBSCRIPTION_TAP_QUARTERLY = 'navigation.subscriptionTapQuarterly',
  SUBSCRIPTION_TAP_TOGGLE = 'navigation.subscriptionTapToggle',
}
